<unity-action-shared [action]="$action()" [disabled]="$disabled()" (clickEvent)="onClickDownload()" />
